import { _ as _sfc_main } from "../../MalarkeyAttachmentPane.vue_vue_type_script_lang-d0f606dc.mjs";
import { resolveComponent, resolveDirective, openBlock, createBlock, normalizeProps, guardReactiveProps, withCtx, createVNode, createTextVNode, toDisplayString, createElementVNode, withDirectives, createCommentVNode, mergeProps, createElementBlock, Fragment, renderList } from "vue";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-3194dc60.mjs";
import "../../i18n-35335a5c.mjs";
import "../../index-38c53cf2.mjs";
import "../../_i18n-e414d464.mjs";
import "../../index-64135f7d.mjs";
import "../../index-703c58ee.mjs";
import "../../malarkeyTwilioAdapter-1c296255.mjs";
import "../../index-13be80af.mjs";
import "../../_commonjsHelpers-ca272635.mjs";
import "../../_debug-8b5c3032.mjs";
import "joi";
import "../../helpers-674591c1.mjs";
import "../../event-socket/malarkeyEventSocketAdapter.es.js";
import "../../otpauth.esm-675c01d0.mjs";
import "../../sudo-bad5b55e.mjs";
import "../../index-fd2245c5.mjs";
import "../../_common-fcf3ef61.mjs";
import "../../MalarkeyContactAvatar-1b079ba3.mjs";
import "../../_density-8094aebe.mjs";
import "../../MPasswordField.vue_vue_type_script_lang-baf1023a.mjs";
import "../../_VTextField-74fe2c1a.mjs";
import "../../index-dbde2d54.mjs";
import "../../_proxiedModel-031e293c.mjs";
import "../../flow-501bd5ba.mjs";
import "../../MalarkeyContactRosterItem.vue_vue_type_script_lang-89c5ac30.mjs";
import "../../_VListItem-508e4b13.mjs";
import "../../MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs";
import "../../MalarkeyConversationListItem.vue_vue_type_script_lang-3da40755.mjs";
import "../../theme-96176369.mjs";
import "../../getCurrentInstance-eec76705.mjs";
import "./MalarkeyChatInputForm.es.js";
const _hoisted_1 = { class: "m-attachment-pane-preview d-flex align-center justify-center flex-grow-1" };
const _hoisted_2 = { class: "m-attachment-pane-info d-flex align-center justify-center" };
const _hoisted_3 = { class: "m-attachment-pane-tabs" };
const _hoisted_4 = { class: "m-attachment-pane-tab-preview-overlay--outer" };
const _hoisted_5 = { class: "m-attachment-pane-tab-preview-overlay--inner" };
const _hoisted_6 = { class: "flex-grow-0 px-4 py-2" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_toolbar_items = resolveComponent("v-toolbar-items");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_MalarkeyAttachmentPreview = resolveComponent("MalarkeyAttachmentPreview");
  const _component_v_responsive = resolveComponent("v-responsive");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_overlay = resolveComponent("v-overlay");
  const _component_v_tab = resolveComponent("v-tab");
  const _component_v_tabs = resolveComponent("v-tabs");
  const _component_MalarkeyChatInputForm = resolveComponent("MalarkeyChatInputForm");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_card = resolveComponent("v-card");
  const _directive_resize = resolveDirective("resize");
  return openBlock(), createBlock(_component_v_card, normalizeProps(guardReactiveProps(_ctx.cardBindings)), {
    default: withCtx(() => [
      createVNode(_component_v_toolbar, {
        color: "transparent",
        flat: "",
        density: "compact",
        class: "flex-grow-0"
      }, {
        default: withCtx(() => [
          createVNode(_component_v_toolbar_title, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }),
          createVNode(_component_v_toolbar_items, null, {
            default: withCtx(() => [
              createVNode(_component_v_btn, {
                icon: "mdi-close",
                disabled: _ctx.isSubmitting,
                onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close"))
              }, null, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      createVNode(_component_v_divider, { class: "flex-grow-0" }),
      createElementVNode("div", _hoisted_1, [
        withDirectives((openBlock(), createBlock(_component_v_responsive, {
          "aspect-ratio": 1,
          ref: "responsiveContainer"
        }, {
          default: withCtx(() => [
            createVNode(_component_MalarkeyAttachmentPreview, {
              file: _ctx.currentFile,
              fit: "contain",
              width: "100%",
              height: _ctx.responsiveContainerWidth,
              size: _ctx.responsiveContainerWidth,
              rounded: false,
              tile: true,
              color: "surface",
              iconSize: _ctx.iconSize,
              iconColor: "primary"
            }, null, 8, ["file", "height", "size", "iconSize"])
          ]),
          _: 1
        })), [
          [_directive_resize, _ctx.updateResponsiveContainerWidth]
        ]),
        createElementVNode("div", _hoisted_2, [
          _ctx.currentFileName ? (openBlock(), createBlock(_component_v_chip, {
            key: 0,
            color: "primary",
            variant: "elevated"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.currentFileName), 1)
            ]),
            _: 1
          })) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_3, [
          createVNode(_component_v_tabs, mergeProps(_ctx.vTabBindings, {
            modelValue: _ctx.currentIndex,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.currentIndex = $event)
          }), {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.vTabsBindings, (bindings) => {
                return openBlock(), createBlock(_component_v_tab, mergeProps({
                  key: bindings.key,
                  ref_for: true
                }, bindings.tab), {
                  default: withCtx(() => [
                    createVNode(_component_MalarkeyAttachmentPreview, mergeProps({ ref_for: true }, bindings.props), {
                      default: withCtx(({ parent }) => [
                        createVNode(_component_v_overlay, {
                          "model-value": bindings.tab.value === _ctx.currentIndex && !_ctx.isSubmitting,
                          contained: true,
                          attach: parent ? parent.$el : void 0,
                          class: "m-attachment-pane-tab-preview-overlay",
                          onClick: ($event) => _ctx.onOverlayClick(bindings.tab.value)
                        }, {
                          default: withCtx(() => [
                            createElementVNode("div", _hoisted_4, [
                              createElementVNode("div", _hoisted_5, [
                                createVNode(_component_v_icon, { size: "30" }, {
                                  default: withCtx(() => [
                                    createTextVNode("mdi-trash-can-outline")
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["model-value", "attach", "onClick"])
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  _: 2
                }, 1040);
              }), 128))
            ]),
            _: 1
          }, 16, ["modelValue"])
        ])
      ]),
      createElementVNode("div", _hoisted_6, [
        _ctx.conversation ? (openBlock(), createBlock(_component_MalarkeyChatInputForm, {
          modelValue: _ctx.currentCaption,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.currentCaption = $event),
          conversation: _ctx.conversation,
          doOnSubmit: _ctx.doOnSubmit,
          "is-externally-submitting": _ctx.isSubmitting,
          key: `caption-for-${_ctx.currentIndex}-${_ctx.currentFileName}`,
          placeholder: _ctx.$t("malarkeyAttachmentPane.caption.placeholder")
        }, null, 8, ["modelValue", "conversation", "doOnSubmit", "is-externally-submitting", "placeholder"])) : createCommentVNode("", true)
      ]),
      createVNode(_component_v_divider, { class: "flex-grow-0" }),
      createVNode(_component_v_toolbar, {
        color: "transparent",
        flat: "",
        density: "compact",
        class: "flex-grow-0"
      }, {
        default: withCtx(() => [
          createVNode(_component_v_spacer),
          createVNode(_component_v_btn, {
            icon: "mdi-send",
            onClick: _ctx.doOnSubmit,
            density: "compact",
            variant: "elevated",
            size: "large",
            color: "success",
            loading: _ctx.isSubmitting
          }, null, 8, ["onClick", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16);
}
const MalarkeyAttachmentPane = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyAttachmentPane.vue"]]);
export {
  MalarkeyAttachmentPane as default
};
//# sourceMappingURL=MalarkeyAttachmentPane.es.js.map
